import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Router} from '@angular/router';
import * as $ from 'jquery';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AngularFireAuth} from 'angularfire2/auth';
import {SweetAlertService} from 'ngx-sweetalert2';
import * as jquery from 'jquery';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {

  form: FormGroup;
  resetForm: FormGroup;

  email: string;
  password: string;
  resetEmail: string;

  constructor(public router: Router, private formBuilder: FormBuilder, private afAuth: AngularFireAuth, private alertService: SweetAlertService) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required, Validators.minLength(8)]]
    });

    this.resetForm = this.formBuilder.group({
      resetEmail: [null, [Validators.required, Validators.email]]
    });
  }

  ngAfterViewInit() {
    $(function () {
      $('.preloader').fadeOut();
    });
    $(function () {
      (<any>$('[data-toggle="tooltip"]')).tooltip();
    });
    $('#to-recover').on('click', function () {
      $('#loginform').slideUp();
      $('#recoverform').fadeIn();
    });
    $('#reset-password').on('click', function () {
      $('#recoverform').slideUp();
      $('#loginform').fadeIn();
    });
  }

  // 로그인
  login() {
    this.afAuth.auth.signInWithEmailAndPassword(this.email, this.password)
      .then(user => {
        this.router.navigate(['dashboard']);
      })
      .catch(error => {
        console.error(error);
        this.alertService.error({title: '로그인 에러'});
      });
  }

  // 비밀번호 찾기
  resetPassword() {
    this.afAuth.auth.sendPasswordResetEmail(this.resetEmail)
      .then(a => {
        console.log(this.resetEmail);
        console.log('reset password');
      })
      .catch(error => {
        console.error(error);
        this.alertService.error({title: '비밀번호 초기화 이메일 보내기 에러'});
      });
  }

}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/login/login.component.ts